import { render, staticRenderFns } from "./MemberLike.vue?vue&type=template&id=484dc621&scoped=true&"
import script from "./MemberLike.vue?vue&type=script&lang=js&"
export * from "./MemberLike.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484dc621",
  null
  
)

component.options.__file = "MemberLike.vue"
export default component.exports